<div id="{{position}}" class="position-relative">
  <div *ngIf="(loadingData$ | async)">
    <div *ngIf="imageBackground && imageBackground.length>0 && innerWidth <= 480" class="mobile-background">
      <div class="visuel">
        <div class="mobile-background-container">
          <img [src]="imageBackground[sliderIndex]" alt="">
        </div>
      </div>
    </div>
    <header [attr.data-aos]="allElementAnimation ? allElementAnimation : null" data-aos-duration="1100"
      class="app-header-background inline-gradient cta-header cta-form-section cta-app-header-background"
      [ngStyle]="{'background-image': style, 'background-color':backgroundColor, 'min-height':minHeight+'px'}"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div *ngIf="imageBackground && imageBackground.length>1 && innerWidth <= 480" class="center global-max-width">
        <ng-container *ngFor="let item of imageBackground; let i = index">
          <a class="tms-bullet-nav" (click)="nextSliderClick(i)"
            [ngClass]="sliderIndex === i ? 'tms-bullet-nav active' : 'tms-bullet-nav'"></a>
        </ng-container>
      </div>
      <div class="app-header-section pt-20 cta-form-header-section global-max-width">
        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start center"
          class="cta-form-container">
          <div [attr.data-aos]="textAnimation ? textAnimation : null" data-aos-duration="1100" fxflex="33"
            [fxFlexOrder]="!leadPosition || leadPosition == 'right' ? 1 : 2" fxFlex.lt-sm="100%">
            <div class="app-header-headline form-headline" [ngStyle]="{ 'text-align': textAlign }">
              <h1 class="mat-h1"
                [ngStyle]="{ 'font-family':titleFontFamily ? titleFontFamilyName : '','text-align': textAlign,'color': titleColor?titleColor:textColor,'font-weight':fontWeight }"
                [innerHtml]="title | safeHtml" [ngClass]="[titleSize]"> </h1>
              <h2 [ngStyle]="{ 'text-align': textAlign,'color': textColor }" [innerHtml]="text | safeHtml"
                [class]="textSize"> </h2>
            </div>
          </div>
          <div [attr.data-aos]="formAnimation ? formAnimation : null" data-aos-duration="1100" fxflex="67"
            [fxFlexOrder]="!leadPosition || leadPosition == 'right' ? 2 : 1" fxFlexOrder="1" fxFlex.lt-sm="100%">
            <div class="try-form-nw">
              <form>
                <h2 *ngIf="leadTitle" class="text-center mat-h1 cta-form-title" [innerHtml]="leadTitle | safeHtml"></h2>
                <div *ngFor="let form of forms; let field = index ">
                  <!-- input -->
                  <section [ngClass]="(positionField === field) ? 'section-control' : ''"
                    *ngIf="form.type === 'text' || form.type === 'email' || form.type === 'phone'">
                    <app-material-input [positionField]="positionField" [field]="field"
                      [formInfos]="{ type: form.type, name: form.name, placeholder: form.placeholder, required: form.required, requiredAlertMessage: form.requiredAlertMessage }"
                      (setValueEvent)="saveForm($event)">
                    </app-material-input>
                  </section>
                  <!-- textarea -->
                  <section [ngClass]="(positionField === field) ? 'section-control' : ''"
                    *ngIf="form.type === 'textarea'">
                    <app-material-textarea [positionField]="positionField" [field]="field"
                      [formInfos]="{ name: form.name, placeholder: form.placeholder, required: form.required, requiredAlertMessage: form.requiredAlertMessage }"
                      (setValueEvent)="saveForm($event)">
                    </app-material-textarea>
                  </section>
                  <!-- checkbox -->
                  <section [ngClass]="(positionField === field) ? 'section-control' : ''"
                    *ngIf="form.type === 'checkbox'">
                    <app-material-checkbox [positionField]="positionField" [field]="field"
                      [formInfos]="{ name: form.name, required: form.required, requiredAlertMessage: form.requiredAlertMessage }"
                      (setValueEvent)="saveForm($event)">
                    </app-material-checkbox>
                  </section>
                  <!-- datepicker -->
                  <section [ngClass]="(positionField === field) ? 'section-control' : ''"
                    *ngIf="form.type === 'datepicker'">
                    <app-material-datepicker [positionField]="positionField" [field]="field" [name]="form.name"
                      (setValueEvent)="saveForm($event)">

                    </app-material-datepicker>
                  </section>
                  <!-- radiobutton -->
                  <section [ngClass]="(positionField === field) ? 'section-control' : ''"
                    *ngIf="form.type === 'radiobutton'">
                    <app-material-radiobutton [positionField]="positionField" [field]="field" [options]="form.options"
                      (setValueEvent)="saveForm($event)">
                    </app-material-radiobutton>
                  </section>
                  <!-- select -->
                  <section [ngClass]="(positionField === field) ? 'section-control' : ''"
                    *ngIf="form.type === 'select'">
                    <app-material-select [positionField]="positionField" [field]="field"
                      [formInfos]="{name: form.name, options: form.options, requiredAlertMessage: form.requiredAlertMessage}"
                      (setValueEvent)="saveForm($event)">
                    </app-material-select>
                  </section>
                  <!-- slider -->
                  <section *ngIf="form.type === 'slider'">
                    <section [ngClass]="(positionField === field) ? 'active-control' : ''">
                      <app-material-slider [positionField]="positionField" [field]="field" [slider]="form.slider"
                        (setValueEvent)="saveForm($event)">
                      </app-material-slider>
                    </section>
                  </section>

                </div>
              </form>
              <div>
                <p class="small-legend">
                  <input type="checkbox" (change)="agreePrivacyPolicy($event)">
                  <ng-container *ngIf="privacyPolicyExist">
                    <span>
                      <a class="privacy-link" [href]="privacyPolicyLink" target="_blank">{{consentText}}</a>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="!privacyPolicyExist">
                    <span>
                      {{consentText}}
                    </span>
                  </ng-container>
                </p>
              </div>
              <div>
                <div class="app-header-start" *ngIf="buttonText && !loading && !(successMsg$ | async)">
                  <button class="btn-large" (click)="submitForm()" [attr.aria-label]="buttonText" mat-raised-button
                    color="primary" [disabled]="!formValid">
                    {{ buttonText }}
                  </button>
                </div>
                <div class="text-center loading-form" *ngIf="loading && !(successMsg$ | async)">
                  <mat-spinner color="accent" [diameter]="40"></mat-spinner>
                </div>
                <div *ngIf="(successMsg$ | async) as successMsg" class="success-msg">
                  {{successMsg}}
                </div>
              </div>
            </div>
            <div *ngIf="textUnderForm" class="text-center cta-form-extra-description"><a
                [href]="linkTextUnderForm | safeUrl">{{textUnderForm}}</a></div>
          </div>
        </div>
      </div>
      <div *ngIf="imageBackground && imageBackground.length>1 && innerWidth > 480" class="center pb-20 pt-20 ">
        <ng-container *ngFor="let item of imageBackground; let i = index">
          <a class="tms-bullet-nav" (click)="nextSliderClick(i)"
            [ngClass]="sliderIndex === i ? 'tms-bullet-nav active' : 'tms-bullet-nav'"></a>
        </ng-container>
      </div>
    </header>
  </div>
</div>